import { PxtraApiClientLegacy } from '@pxtra-client-lib-legacy';
import AuthenticationStore from '../authenticationStore';
import { action, makeObservable, observable, when } from 'mobx';

export abstract class BaseStore {
  loading = false;

  constructor(
    protected apiClient: PxtraApiClientLegacy,
    private authenticationStore: AuthenticationStore
  ) {
    this.apiClient = apiClient;
    makeObservable(this, { loading: observable, clear: action });
    when(
      () => !this.authenticationStore.isLoggedIn,
      () => {
        this.clear();
      }
    );
  }

  public abstract clear(): void;
}
